import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformationService} from "../../services/information.service";
import {Subject, takeUntil} from "rxjs";
import {environment} from "../../../environments/environment";
import {  SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'franchise',
  templateUrl: './franchise.component.html',
  styleUrls: ['./franchise.component.less']
})
export class FranchiseComponent implements OnInit, OnDestroy{

  franchise:SafeHtml;

  private destroySubject: Subject<void> = new Subject();

  constructor(
    private informationService: InformationService
  ) {
  }


  ngOnInit() {

    this.informationService.getFrontParams().pipe(
      takeUntil(this.destroySubject),
    )
      .subscribe(
      (res: any) => {
        let franchiseHtml = res.results.find ((value:any) =>  value.name == 'franchise')?.value;
        this.franchise = this.informationService.getSanitizeString(franchiseHtml);

    })

  }

  ngOnDestroy() {
    this.destroySubject.next();
  }

}




